// ─── Shared constants for Framework Master ──────────────────────────────────

export const FRAMEWORK_TYPES = [
  "Regulatory",
  "Industry Standard",
  "Best Practice",
  "Government Mandate",
  "International Standard",
  "Regional Compliance",
];

export const IMPL_STATUSES = [
  "Not Implemented",
  "Partially Implemented",
  "Implemented",
  "Under Review",
];

export const EMPTY_FW = {
  name: "",
  description: "",
  country_or_origin: "",
  framework_type: "",
  is_active: true,
};

export const EMPTY_CTRL = {
  control_id: "",
  title: "",
  category: [],
  description: "",
  control_owner: [],
  evidence_type: "",
  implementation_status: "Not Implemented",
  risk_mapping: "",
  risk_ids: [],
  is_active: true,
};

/** Returns a Tailwind class string for an implementation status badge. */
export const statusClass = (s) => {
  if (!s) return "bg-gray-100 text-gray-500";
  if (s === "Implemented") return "bg-green-100 text-green-700";
  if (s === "Partially Implemented") return "bg-yellow-100 text-yellow-700";
  if (s === "Under Review") return "bg-blue-100 text-blue-700";
  return "bg-red-50 text-red-600";
};

/** Returns a Badge variant for an implementation status. */
export const statusBadgeVariant = (s) => {
  if (!s) return "secondary";
  if (s === "Implemented") return "success";
  if (s === "Partially Implemented") return "warning";
  if (s === "Under Review") return "info";
  return "error";
};
